<mulo-nav-main-layout
    [navPosition]="media.is('xs') ? 'top' : 'left'"
    [navSize]="media.is('xs') ? 48 : media.is('md') ? 170 : 200"
    navBehavior="sticky"
    [stickyOffset]="48"
>
    <div slot="nav" #contentNavParent>
        @if (media.is('lt-sm')) {
            @if (!isLoading) {
                <mulo-breadcrumbs-nav
                    [items]="profileProjectsService.facetsForMobile"
                    [selectedIndex]="profileProjectsService.selectedIndex$ | async"
                    (navDirection)="tabDirection = $event"
                    (itemSelected)="onMobileFacetChange($event)"
                >
                </mulo-breadcrumbs-nav>
            } @else {
                <div class="content-nav-placholders" style="position: absolute; width: 100%" @opacityOutAnimation>
                    <content-loader
                        foregroundColor="#eeeeee"
                        backgroundColor="#dddddd"
                        [style]="{ height: 180, width: 160 }"
                        viewBox="0,0,160,180"
                        [rtl]="i18nService.isLangRtl()"
                    >
                        <svg:rect x="14" y="18" rx="2" ry="2" width="80" height="7" />
                        <svg:rect x="14" y="54" rx="2" ry="2" width="90" height="7" />
                        <svg:rect x="14" y="92" rx="2" ry="2" width="80" height="7" />
                        <svg:rect x="14" y="128" rx="2" ry="2" width="110" height="7" />
                    </content-loader>
                </div>
            }
        }

        @if (media.is('gt-xs')) {
            @if (!isLoading) {
                <nav
                    mat-tab-nav-bar
                    exlAutomationClass="output-nav"
                    [muloVerticalTabs]="profileProjectsService.selectedIndex$ | async"
                    class="content-nav is-scaling"
                    color="default"
                    attr.aria-label="{{ 'research.profile.section.projects' | translate }}"
                    [disablePagination]="true"
                    [tabPanel]="tabPanel"
                >
                    @for (tab of profileProjectsService.facets; track tab; let i = $index) {
                        @if (tab.count > 0) {
                            <a
                                mat-tab-link
                                class="italic"
                                [active]="rla.isActive"
                                [routerLink]="[tab.value]"
                                [queryParams]="{ institution: institutionCode }"
                                #rla="routerLinkActive"
                                routerLinkActive
                                (click)="updateSelectedIndex(tab)"
                            >
                                <span class="cdk-visually-hidden">{{
                                    'research.aria.output.list.output.view' | translate
                                }}</span>
                                <span>
                                    <ng-container>{{
                                        'research.projects.facet.' + tab.label | translate
                                    }}</ng-container>
                                    <span class="margin-left-xs tab-count">({{ tab.count }})</span>
                                </span>
                            </a>
                        }
                    }
                </nav>
            } @else {
                <div class="content-nav-placholders" style="position: absolute; width: 100%" @opacityOutAnimation>
                    <content-loader
                        foregroundColor="#eeeeee"
                        backgroundColor="#dddddd"
                        [style]="{ height: 180, width: 160 }"
                        viewBox="0,0,160,180"
                        [rtl]="i18nService.isLangRtl()"
                    >
                        <svg:rect x="14" y="18" rx="2" ry="2" width="80" height="7" />
                        <svg:rect x="14" y="54" rx="2" ry="2" width="90" height="7" />
                        <svg:rect x="14" y="92" rx="2" ry="2" width="80" height="7" />
                        <svg:rect x="14" y="128" rx="2" ry="2" width="110" height="7" />
                    </content-loader>
                </div>
            }
        }
    </div>

    <div slot="main" class="padding-left-sm">
        <div class="output-content">
            <div class="position-relative">
                <router-outlet #outlet="outlet"></router-outlet>
                <mat-tab-nav-panel #tabPanel></mat-tab-nav-panel>
            </div>
        </div>
    </div>
</mulo-nav-main-layout>
